/* ===========================================================================
   ADD TO CART, WITHOUT LEAVING THE PAGE
   The custom sections post a normal product form, which reloads onto the cart
   and loses the person's place. This intercepts that: adds over fetch, hands
   the new markup to the theme's own cart drawer, and lets the drawer open
   itself. Nothing here reimplements the drawer, it only feeds it.
   =========================================================================== */
(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function drawer() { return document.querySelector('cart-drawer'); }

  function refresh(state) {
    var d = drawer();
    if (d && typeof d.renderContents === 'function') {
      d.renderContents(state);
    } else {
      window.location = '/cart';
    }
  }

  function busy(button, on) {
    if (!button) return;
    button.disabled = on;
    button.classList.toggle('is-adding', on);
  }

  /* ---- adding ---- */

  function submit(form, button) {
    var body = new FormData(form);
    body.append('sections', SECTIONS);
    body.append('sections_url', window.location.pathname);

    busy(button, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) {
          /* Shopify answers an unbuyable line with a status and a description.
             Say it where the button is rather than swallowing it. */
          var note = form.querySelector('[data-fc-cart-error]');
          if (!note) {
            note = document.createElement('p');
            note.className = 'fc-cart-error';
            note.setAttribute('data-fc-cart-error', '');
            form.appendChild(note);
          }
          note.textContent = state.description || state.message || 'That could not be added.';
          return;
        }
        refresh(state);
      })
      .catch(function () { form.submit(); })
      .finally(function () { busy(button, false); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    /* leave the theme's own product form alone, it already does this */
    if (form.closest('product-form')) return;
    if (!form.closest('.fc-duo, .fc-brick, .fc-routines, .fc-dshop, .fc-sub, .fc-social')) return;

    e.preventDefault();
    submit(form, form.querySelector('[type="submit"]'));
  });

  /* ---- the subscribe switch inside the drawer ----
     Turning it on puts every eligible line onto its selling plan, which is what
     actually earns the free shipping. Off takes them back to a one time buy.
     Lines are changed one at a time because /cart/change.js only takes one. */

  function setPlan(planId) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var steps = cart.items.map(function (item, i) {
          return function () {
            var payload = {
              line: i + 1,
              quantity: item.quantity,
              sections: SECTIONS
            };
            if (planId) {
              payload.selling_plan = planId;
            } else {
              payload.selling_plan = '';
            }
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body: JSON.stringify(payload)
            }).then(function (r) { return r.json(); });
          };
        });

        return steps.reduce(function (chain, step) {
          return chain.then(step);
        }, Promise.resolve());
      });
  }

  document.addEventListener('change', function (e) {
    var toggle = e.target.closest ? e.target.closest('[data-fc-ship-toggle]') : null;
    if (!toggle) return;

    var block = toggle.closest('[data-fc-ship]');
    var planId = block ? block.getAttribute('data-plan') : '';
    if (block) block.classList.add('is-working');

    setPlan(toggle.checked ? planId : '')
      .then(function (state) {
        if (state && state.sections) { refresh(state); }
        else { return fetch('/cart.js').then(function(){ window.location.reload(); }); }
      })
      .catch(function () { window.location.reload(); });
  });
})();
